import { convertNowToISO } from 'context/DateProvider/utils/convertNowToISO';

export const initialDateTimeRange = {
  from: convertNowToISO('now-1h'),
  to: convertNowToISO('now'),
};
